import pythonApiClient from './pythonBaseApi';

const BASE_PATH = '/mantenimientos/hoteleria/estaciones-impresion';

const estacionesImpresionApi = {
    getAll: async (proyectoId) => {
        return pythonApiClient.get(`${BASE_PATH}/`, {
            headers: { 'X-Proyecto-ID': proyectoId }
        });
    },

    create: async (proyectoId, data) => {
        return pythonApiClient.post(`${BASE_PATH}/`, data, {
            headers: { 'X-Proyecto-ID': proyectoId }
        });
    },

    update: async (proyectoId, id, data) => {
        return pythonApiClient.put(`${BASE_PATH}/${id}`, data, {
            headers: { 'X-Proyecto-ID': proyectoId }
        });
    },

    delete: async (proyectoId, id) => {
        return pythonApiClient.delete(`${BASE_PATH}/${id}`, {
            headers: { 'X-Proyecto-ID': proyectoId }
        });
    }
};

export default estacionesImpresionApi;
